/*
 * @Author: Zhouqi
 * @Date: 2025-10-21 16:53:42
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-20 11:20:36
 */

import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import baseConfig from '@/config';

const key = 'f_text_to_video_state';

type TextToVideoState = {
  formValues: {
    [key: string]: any;
  };
  setFormValues: (values: Partial<TextToVideoState['formValues']>) => void;
  reset: () => void;
};

const initialData: TextToVideoState['formValues'] = {
  modelID: 15,
};

export const useTextToVideoStore = createWithEqualityFn<TextToVideoState>()(
  devtools(
    persist(
      (set) => ({
        formValues: initialData,
        setFormValues: (values: Partial<TextToVideoState['formValues']>) =>
          set(() => ({ formValues: values })),
        reset: () => {
          set({ formValues: { ...initialData } });
        },
      }),
      {
        name: key,
        storage: createJSONStorage(() => localStorage),
        partialize: ({ formValues }) => ({
          formValues,
        }),
      },
    ),
    {
      name: key,
      enabled: baseConfig.debuggable,
    },
  ),
);
